import type { WaypointPosition } from './types';

/**
 * Gets the viewport bounds from rootBounds with fallback to window dimensions.
 */
function getViewportBounds(rootBounds: DOMRectReadOnly | null, horizontal: boolean) {
	if (horizontal) {
		return {
			start: rootBounds?.left ?? 0,
			end: rootBounds?.right ?? window.innerWidth,
		};
	}
	return {
		start: rootBounds?.top ?? 0,
		end: rootBounds?.bottom ?? window.innerHeight,
	};
}

/**
 * Gets the element bounds based on orientation.
 */
function getElementBounds(rect: DOMRectReadOnly, horizontal: boolean) {
	if (horizontal) {
		return { start: rect.left, end: rect.right };
	}
	return { start: rect.top, end: rect.bottom };
}

/**
 * Calculates the position of the waypoint relative to the root element (scrollable container).
 * For horizontal mode, 'above' means left of root, 'below' means right of root.
 * Uses entry.rootBounds for accurate position relative to the scroll container.
 */
export function calculatePosition(entry: IntersectionObserverEntry, horizontal = false): WaypointPosition {
	const { boundingClientRect, rootBounds } = entry;
	const viewport = getViewportBounds(rootBounds, horizontal);
	const element = getElementBounds(boundingClientRect, horizontal);

	if (element.end < viewport.start) {
		return 'above';
	}
	if (element.start > viewport.end) {
		return 'below';
	}
	return 'inside';
}
